import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY || '';

export const isSupabaseConnected = () => {
  return Boolean(supabaseUrl && supabaseAnonKey);
};

let _supabase: SupabaseClient | null = null;

if (supabaseUrl && supabaseAnonKey) {
  try {
    _supabase = createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
      },
    });
  } catch (e) {
    console.warn('⚠️ Erro ao inicializar Supabase:', e);
    _supabase = null;
  }
} else {
  console.warn('⚠️ Supabase não configurado.');
}

export const supabase = _supabase as SupabaseClient;
